export const USER_DATA_REQUEST = "USER_DATA_REQUEST";
export const USER_DATA_SUCCESS = "USER_DATA_SUCCESS";
export const USER_DATA_FAIL = "USER_DATA_FAIL";
export const USER_DATA_CLEAR_ERRORS = "USER_DATA_CLEAR_ERRORS";

export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";
export const UPDATE_USER_CLEAR_ERRORS = "UPDATE_USER_DATA_CLEAR_ERRORS";

export const USER_AUTH_REQUEST = "USER_AUTH_REQUEST";
export const USER_AUTH_SUCCESS = "USER_AUTH_SUCCESS";
export const USER_AUTH_FAIL = "USER_AUTH_FAIL";
export const USER_AUTH_CLEAR_ERRORS = "USER_AUTH_CLEAR_ERRORS";

export const USER_REG_REQUEST = "USER_REG_REQUEST";
export const USER_REG_SUCCESS = "USER_REG_SUCCESS";
export const USER_REG_FAIL = "USER_REG_FAIL";
export const USER_REG_CLEAR_ERRORS = "USER_REG_CLEAR_ERRORS";

export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL";
export const CHANGE_PASSWORD_CLEAR_ERRORS = "CHANGE_PASSWORD_CLEAR_ERRORS";
